import style from "./Faq.module.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import HorizontalSeparator from "../horizontal-separetor/HorizontalSeparetor";
import { Button } from "@mui/material";
const faqItems = [
  {
    id: 0,
    domanda: "Chi è Affida SRL?",
    risposta:
      "Affida è una società di Mediazione Creditizia iscritta presso OAM al numero M325, con oltre 600 agenti in tutta Italia 🇮🇹",
  },
  {
    id: 1,
    domanda: "Perché scegliere noi?",
    risposta:
      "Un solo interlocutore, oltre 100 istituti di credito convenzionati. Scegliendo un consulente Affida amplifichi la possibilità di accesso al credito e usufruisci dei prodotti maggiormente competitivi sul mercato.",
  },
  {
    id: 2,
    domanda: "Dove opera Affida?",
    risposta: "Siamo attivi su tutto il territorio Italiano, puoi scegliere se gestire la tua richiesta online oppure in presenza."
  },
  {
    id: 3,
    domanda: "Quali costi ci sono e quando si pagano?",
    risposta:
      "Non ci sono costi iniziali. Eventuali costi di mediazione verranno comunicati e motivati dall'agente in fase di consulenza.",
  },
  {
    id: 4,
    domanda: "Quanto tempo serve per accendere un mutuo?",
    risposta:
      "Dipende dalla tipologia del mutuo e dalle caratteristiche dell'operazione, mediamente i tempi di delibera vanno dai 5 ai 15 giorni, i tempi di erogazione sono mediamente di 40 / 60 giorni.",
  },
  {
    id: 5,
    domanda: "Quali documenti servono?",
    risposta:
      "Carta ID e Cod. Fiscale, certificato di residenza e stato di famiglia. Certificazione reddituale (CU o Unico), infine i documenti dell'immobile oggetto di ipoteca quali: atto di provenienza, visura catastale e planimetria.",
  },
];

export const Faq = ({ ctaClick }: { ctaClick: () => void }) => {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <div className={`${style.faqContainer} glass`}>
      <span className={style.faqTitle}>Domande frequenti</span>
      <span className={style.faqSubTitle}>
        Alcune delle domande che ci fanno più spesso
      </span>
      {faqItems.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id} className={style.faqWrapper}>
            <div className={style.faqDomandaBox}>
              <span>{item.domanda}</span>
              <span
                className={style.faqOpenClose}
                onClick={() => setOpenId(isOpen ? null : item.id)}
                aria-expanded={isOpen}
                aria-controls={`faq-${item.id}`}
              >
                {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </span>
            </div>
            <div
              className={`${style.answerWrapper} ${isOpen ? style.opened : ""}`}
            >
              <div className={style.answerInner}>
                <span>{item.risposta}</span>
              </div>
            </div>
            <HorizontalSeparator
              maxWidth={"100%"}
              color={isOpen ? "#333333" : "#e2e2e2"}
            />
          </div>
        );
      })}
      <Button
        variant={"contained"}
        style={{ maxWidth: "275px", marginTop: "1em", alignSelf: "center" }}
        onClick={() => ctaClick()}
      >
        Chiedi una consulenza!
      </Button>
    </div>
  );
};
